import { ReactElement, memo } from 'react';
import Tooltip from '@mui/material/Tooltip';

import { useRouteStateInfo } from '~hooks/index';

import { RouteStateChipProps } from './types';
import { RouteStateChipRoot } from './styles';

const RouteStateChip = ({
  stateId,
  isTemplate = false,
  size = 'medium',
}: RouteStateChipProps): ReactElement => {
  const { description, color, tooltipMessage } = useRouteStateInfo(
    stateId,
    isTemplate,
  );

  return (
    <Tooltip title={tooltipMessage} arrow>
      <RouteStateChipRoot
        variant="filled"
        label={description}
        color={color}
        size={size}
      />
    </Tooltip>
  );
};

export default memo(RouteStateChip);
